// extracted by mini-css-extract-plugin
module.exports = {"stars__path":"styles_stars__path__QKIlq","stars__last":"styles_stars__last__xkDkD","stars--green":"styles_stars--green__lmRZE","stars--green300":"styles_stars--green300__EszTo"};